import React from "react";
import Dashboard from "../../common/Dashboard";
import DashboardConfig from "../system-admin/Dashboard/DashboardConfig";

export default function ContentAdminDashboard() {
  return (
    <Dashboard sidebarType="Content Admin">
      <DashboardConfig />
    </Dashboard>
  );
}
